import { store, getContext, getElement } from "@wordpress/interactivity";

const navs = document.querySelectorAll(".wp-block-emb-navigation");
const menuTriggers = document.querySelectorAll(
	".wp-block-emb-navigation-mobile-trigger",
);

navs.forEach((nav) => {
	const iteractiveNavigation = nav.getAttribute("data-wp-interactive");

	if (iteractiveNavigation) {
		const { actions } = store(iteractiveNavigation, {
			actions: {
				toggleNavigationMenu: (event) => {
					const context = getContext();
					const { ref } = getElement();

					event.preventDefault();

					if (context[ref.id]) {
						actions.closeAllMenus();
					} else {
						actions.closeAllMenus();
						context[ref.id] = true;
					}
				},
				closeAllMenus: () => {
					const context = getContext();
					Object.keys(context).forEach((item) => (context[item] = false));
				},
				openMenu: (event) => {
					const context = getContext();
					const { ref } = getElement();

					event.preventDefault();

					if (!context[ref.id]) {
						actions.closeAllMenus();
						context[ref.id] = true;
					}
				},
				closeMenu: (event) => {
					const context = getContext();
					const { ref } = getElement();

					event.preventDefault();

					if (context[ref.id]) {
						context[ref.id] = false;
					}
				},
			},
			callbacks: {
				init: () => {
					actions.closeAllMenus();
				},
				closeMenu: (event) => {
					if (!event.target.closest(".wp-block-emb-navigation-item")) {
						actions.closeAllMenus();
					}
				},
			},
		});
	}
});

menuTriggers.forEach((trigger) => {
	trigger.addEventListener("click", (event) => {
		trigger.classList.toggle("is-active");
		const triggerId = trigger.getAttribute("data-id");

		Array.from(navs).find((nav) => {
			if (nav.id === triggerId) {
				nav.classList.toggle("is-active");
			}
		});
	});
});
